import { MapPin, Navigation, Car } from "lucide-react";

// Stylised (no external key) map: normalises lat/lng of pickup, dropoff and taxis onto a grid.
export function MapView({ pickup, dropoff, offers = [], onMarker }) {
  const pts = [];
  if (pickup) pts.push(pickup);
  if (dropoff) pts.push(dropoff);
  offers.forEach((o) => o.lat && pts.push({ lat: o.lat, lng: o.lng }));
  const lats = pts.map((p) => p.lat), lngs = pts.map((p) => p.lng);
  const minLat = Math.min(...lats), maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs), maxLng = Math.max(...lngs);
  const pad = 0.12;
  const pos = (lat, lng) => ({
    top: `${8 + (1 - (lat - minLat) / ((maxLat - minLat) || 1)) * 84}%`,
    left: `${8 + ((lng - minLng) / ((maxLng - minLng) || 1)) * 84}%`,
  });

  const p1 = pickup ? pos(pickup.lat, pickup.lng) : null;
  const p2 = dropoff ? pos(dropoff.lat, dropoff.lng) : null;

  return (
    <div className="relative h-full min-h-[420px] w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 map-grid">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-light/40 to-transparent" />
      {p1 && p2 && (
        <svg className="absolute inset-0 h-full w-full" style={{ zIndex: 1 }}>
          <line x1={p1.left} y1={p1.top} x2={p2.left} y2={p2.top} stroke="#1D4ED8" strokeWidth="2.5" strokeDasharray="7 6" strokeLinecap="round" />
        </svg>
      )}
      {offers.filter((o) => o.lat).slice(0, 12).map((o) => {
        const p = pos(o.lat, o.lng);
        return (
          <button key={o.offer_id} onClick={() => onMarker?.(o)} data-testid={`map-marker-${o.offer_id}`}
            style={{ ...p, zIndex: 2 }} className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-1.5 shadow-md ring-1 ring-slate-200 transition hover:scale-110 hover:ring-brand">
            <Car size={14} className="text-navy" />
          </button>
        );
      })}
      {p1 && <div style={{ ...p1, zIndex: 3 }} className="absolute -translate-x-1/2 -translate-y-full">
        <div className="flex flex-col items-center"><span className="rounded-md bg-navy px-2 py-0.5 text-[10px] font-semibold text-white shadow">Pickup</span><MapPin size={26} className="fill-navy text-white -mt-0.5" /></div>
      </div>}
      {p2 && <div style={{ ...p2, zIndex: 3 }} className="absolute -translate-x-1/2 -translate-y-full">
        <div className="flex flex-col items-center"><span className="rounded-md bg-brand px-2 py-0.5 text-[10px] font-semibold text-white shadow">Drop-off</span><Navigation size={24} className="fill-brand text-white -mt-0.5" /></div>
      </div>}
    </div>
  );
}
